
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"120","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"4","y":"4","width":"92","height":"112","rx":"4","fill":"#fff"}}),_c('rect',{attrs:{"x":"2","y":"2","width":"96","height":"116","rx":"6","stroke":"#C2C2C2","stroke-opacity":".18","stroke-width":"4"}}),_c('rect',{attrs:{"x":"4","y":"4","width":"92","height":"112","rx":"4","fill":"#fff"}}),_c('rect',{attrs:{"x":"3","y":"3","width":"94","height":"114","rx":"5","stroke":"#C2C2C2","stroke-opacity":".18","stroke-width":"2"}}),_c('rect',{attrs:{"x":"3.5","y":"3.5","width":"93","height":"113","rx":"4.5","stroke":"#C2C2C2","stroke-opacity":".4"}}),_c('g',{attrs:{"opacity":".4","fill":"#9AA5BB","fill-opacity":".75"}},[_c('path',{attrs:{"d":"M42.922 23.79c0-2.09-1.716-3.79-3.827-3.79-2.111 0-3.828 1.7-3.828 3.79 0 2.091 1.717 3.79 3.828 3.79 2.11 0 3.827-1.699 3.827-3.79zM69.516 46a.48.48 0 00.383-.776L56.169 29.14c-.019-.024-.043-.042-.06-.06a.485.485 0 00-.676.06l-9.455 11.104-5.944-6.988c-.018-.024-.042-.042-.06-.06a.485.485 0 00-.676.06L29.114 45.218a.49.49 0 00-.114.308c0 .26.215.474.478.474h40.038z"}})]),_c('path',{attrs:{"opacity":".8","fill":"#9AA5BB","d":"M18 54h64v6H18zM26 64h48v6H26z"}}),_c('rect',{attrs:{"opacity":".98","x":"30","y":"82","width":"40","height":"12","rx":"6","fill":"#0CF"}})])
          )
        }
      }
    